import anime from 'animejs';
import { BaseComponent } from '../../components/BaseComponent';
class AnimateOnEntry extends BaseComponent {
  constructor(rootElement: HTMLElement) {
    super(rootElement);
  }

  public observer: IntersectionObserver;

  private initObserver() {
    if (this.observer == null) {
      const options = {
        root: null,
        rootmargin: '0px',
        threshold: 0.2,
      };

      this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);
      const childTargets = this.rootElement.querySelectorAll('section');

      childTargets.forEach((target) => {
        if (target.className !== 'modal-videoplayer') {
          target.classList.add('anim', 'anim--on-entry');
        }
        this.observer.observe(target);
      });
    }
  }

  private wrapString(elements: NodeListOf<Element>, className: string, searchValue: string | RegExp) {
    elements.forEach((element) => {
      element.innerHTML = element.textContent?.replace(searchValue, `<span class='${className}' style='display: inline-block'>$&</span>`)!;
    });
  }

  private handleIntersect(entries: IntersectionObserverEntry[], observer: IntersectionObserver) {
    entries.forEach((entry) => {
      const target = entry.target as HTMLElement;
      const targetClassName = `${target.dataset.class}--play-animation`;

      if (target.className === 'modal-videoplayer') {
        observer.unobserve(entry.target);
      }

      if (entry.isIntersecting) {
        target.classList.add(targetClassName, 'anim--play');

        // invoke typewriter animation
        const typewriterAnimElements = target.getElementsByClassName('js-typewriter-animation');
        if (typewriterAnimElements.length !== 0) {
          this.handleTypewriterAnimation(typewriterAnimElements);
        }

        // add animation class to slider card children
        if (target.classList.contains('slider')) {
          const sliderSlides = target.querySelectorAll('.slider__slide');

          // trigger slider animation
          window.dispatchEvent(new CustomEvent('onSliderEntry'));

          sliderSlides.forEach((sliderSlide) => {
            const sliderCard = sliderSlide.firstElementChild;
            const sliderCardClasses: string[] = sliderCard?.className.split(' ')!;
            sliderCard?.classList.add(`${sliderCardClasses[0]}--play-animation`);

            Promise.all(
              // @ts-ignore
              sliderSlide.getAnimations({ subtree: true })
                .map(animation => animation.finished),
            ).then(() => sliderCard?.classList.remove(`${sliderCardClasses[0]}--play-animation`));
          });
        }

        Promise.all(
          // @ts-ignore
          entry.target.getAnimations({ subtree: true })
            .map(animation => animation.finished),
        ).then(() => entry.target.classList.remove(`${target.dataset.class}--play-animation`));

        // remove childTarget from observer
        observer.unobserve(entry.target);
      }
    });
  }

  private handleTypewriterAnimation(elements: HTMLCollectionOf<Element>) {
    Array.from(elements).forEach((element) => {
      const timeline = anime.timeline({
        loop: 1,
        autoplay: true,
        duration: 300,
        easing: 'easeInOutQuad',
      });

      const targets = element.querySelectorAll('.letter');

      timeline
      .add({
        targets,
        translateY: [40, 0],
        opacity: [0, 1],
        delay: (el, i) => 20 * (i + 1),
      });
    });
  }

  public init() {
    window.onload = () => {
      const modal = this.rootElement.querySelector('.fullscreen-modal');
      if (modal != null && modal?.classList.contains('fullscreen-modal--active')) {
        const button = modal.querySelector('.js-modal-close');
        if (button != null) {
          button?.addEventListener('click', () => this.initObserver());
        }
      } else {
        this.initObserver();
      }
    };

    // wrap words and letter in spans for animation
    const elements = this.rootElement.querySelectorAll('.js-typewriter-animation');
    this.wrapString(elements, 'word', /\S+/g);
    const words = this.rootElement.querySelectorAll('.word');
    this.wrapString(words, 'letter', /\S/g);
  }
}

export default AnimateOnEntry;
